<script>
import axios from "axios";
import { Translator } from "vue-google-translate";
// import simplebar from "simplebar-vue";
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      arrayOfCountries: [
        {
          code: "en|en",
          title: "English",
        },

        {
          code: "en|fr",
          title: "French",
        },

        {
          code: "en|ar",

          title: "Arabic",
        },

        {
          code: "en|es",

          title: "Spanish",
        },

        {
          code: "en|de",

          title: "German",
        },

        {
          code: "en|sw",

          flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/ke.svg",

          title: "Kiswahili",
        },

        {
          code: "en|lg",

          flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/ug.svg",

          title: "Luganda",
        },
      ],
    };
  },
  components: {
    Translator,
  },
  methods: {
    customEvent() {
      this.$router.push(this.$route.query.redirectFrom || { name: "default" });
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "logos/" + name;
      return imagelink;
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box" style="background: #000;">
          <router-link tag="a" to="/" class="logo">
            <span class="logo-sm">
              <span v-if="userData.logo != 0">
                <img :src="getFiles(userData.logo)" height="50" />
              </span>
              <span v-else>
                <img src="@/assets/images/logo.png" height="50" />
              </span>
            </span>
            <span class="logo-lg">
              <span v-if="userData.logo != 0">
                <img :src="getFiles(userData.logo)" height="50" />
              </span>
              <span v-else>
                <img src="@/assets/images/logo.png" height="50" />
              </span>
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <span toggle-class="header-item" class="pt-4 d-none d-lg-block">
          <span class="h5 text-primary">
            <b>{{ userData.school }}</b>
          </span>
          <br />
          <small class="me-3"
            ><i class="fas fa-map-marker-alt"></i> {{ userData.location }}
          </small>
          <small
            ><i class="fas fa-phone-alt"></i> {{ userData.contact }}
          </small>
        </span>
      </div>

      <div class="d-flex">
        <span v-if="userData.permissions['view_reports'] == 1">
          <b-dropdown
            variant="black"
            class="dropdown-mega"
            toggle-class="header-item"
            menu-class="dropdown-megamenu"
          >
            <template v-slot:button-content
              ><i class="fas fa-receipt"></i> Reports
              <i class="mdi mdi-chevron-down"></i>
            </template>
            <div class="row">
              <div class="col-md-4">
                <h5 class="font-size-14 mt-0">Students Performance</h5>
                <ul class="list-unstyled megamenu-list">
                  <li>
                    <router-link to="reportcards">Students Reports</router-link>
                  </li>
                  <li>
                    <router-link to="classperformance"
                      >Class Performances</router-link
                    >
                  </li>
                  <li>
                    <router-link to="divisionbyclass"
                      >Divisions By Class</router-link
                    >
                  </li>
                  <li>
                    <router-link to="divisionbysubject"
                      >Subject Analysis</router-link
                    >
                  </li>
                  <li>
                    <router-link to="comingsoon"
                      >By Gender/ Section</router-link
                    >
                  </li>
                </ul>
              </div>
              <div class="col-md-4">
                <h5 class="font-size-14 mt-0">Fees Reports</h5>
                <ul class="list-unstyled megamenu-list">
                  <li>
                    <router-link to="feessummaries">Fees Summaries</router-link>
                  </li>
                  <li>
                    <router-link to="feespaymentsledger">
                      Fees Payment ledger</router-link
                    >
                  </li>
                  <li>
                    <router-link to="optionalfeespayments"
                      >Optional Fees Report</router-link
                    >
                  </li>
                  <li>
                    <router-link to="feesbreakdownreport"
                      >Fees Break Down Reports</router-link
                    >
                  </li>
                  <li>
                    <router-link to="accountsanalysis"
                      >Accounts Analysis</router-link
                    >
                  </li>
                </ul>
              </div>
              <div class="col-md-4">
                <h5 class="font-size-14 mt-0">Financial Reports</h5>
                <ul class="list-unstyled megamenu-list">
                  <li>
                    <router-link to="chartsofaccount"
                      >Charts of Account</router-link
                    >
                  </li>
                  <li>
                    <router-link to="balancesheet">Balance Sheet</router-link>
                  </li>
                  <li>
                    <router-link to="trialbalance">Trial Balance</router-link>
                  </li>
                  <li>
                    <router-link to="incomeandexpenditure"
                      >Income and Expenditure</router-link
                    >
                  </li>
                  <li>
                    <router-link to="moneytransfers"
                      >Money Transfers</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </b-dropdown>
        </span>

        <span v-if="userData.permissions['view_settings'] == 1">
          <b-dropdown
            variant="black"
            class="dropdown-mega"
            toggle-class="header-item"
            menu-class="dropdown-megamenu"
          >
            <template v-slot:button-content
              ><i class="fas fa-cog fa-spin"></i> Settings
              <i class="mdi mdi-chevron-down"></i>
            </template>
            <div class="row">
              <div class="col-md-2">
                <h5 class="font-size-14 mt-0">
                  School Management
                </h5>
                <ul
                  class="list-unstyled megamenu-list"
                  v-if="userData.permissions['school_mgt'] == 1"
                >
                  <li>
                    <router-link to="profile">School Profile</router-link>
                  </li>
                  <li>
                    <router-link to="schoolclasses">View Classes</router-link>
                  </li>
                  <li>
                    <router-link to="schoolstreams">View Streams</router-link>
                  </li>
                  <li>
                    <router-link to="schoolhouses">View Houses</router-link>
                  </li>
                  <li>
                    <router-link to="schoolterms">School Terms</router-link>
                  </li>
                  <li>
                    <router-link to="feescategories"
                      >Fees Categories</router-link
                    >
                  </li>
                  <li>
                    <router-link to="feesbreakdown">Fees Breakdown</router-link>
                  </li>
                  <li>
                    <router-link to="paymentoptions"
                      >Payment Options</router-link
                    >
                  </li>
                </ul>
              </div>
              <div class="col-md-2">
                <h5 class="font-size-14 mt-0">
                  Class Management
                </h5>
                <ul
                  class="list-unstyled megamenu-list"
                  v-if="userData.permissions['class_mgt'] == 1"
                >
                  <li>
                    <router-link to="subjects">School Subjects</router-link>
                  </li>
                  <li>
                    <router-link to="competences">Competences</router-link>
                  </li>
                  <li>
                    <router-link to="combinations"
                      >A'level Combinations</router-link
                    >
                  </li>
                  <li>
                    <router-link to="papers"
                      >A'level Subject Papers</router-link
                    >
                  </li>
                  <li><router-link to="examsets"> Exam Sets</router-link></li>
                  <li>
                    <router-link to="examsettings">Exam Settings</router-link>
                  </li>
                  <li>
                    <router-link to="optionalfees">Optional Fees</router-link>
                  </li>
                  <li>
                    <router-link to="busaries">Bursary Categories</router-link>
                  </li>
                </ul>
              </div>
              <div class="col-md-2">
                <h5 class="font-size-14 mt-0">
                  Staff Management
                </h5>
                <ul
                  class="list-unstyled megamenu-list"
                  v-if="userData.permissions['staff_mgt'] == 1"
                >
                  <li><router-link to="users">System Users</router-link></li>
                  <li><router-link to="roles">System Roles</router-link></li>
                  <li>
                    <router-link to="permissions"
                      >System Permissions</router-link
                    >
                  </li>
                  <li>
                    <router-link to="olevelstaffload">Staff Load</router-link>
                  </li>
                  <!-- <li>
                    <router-link to="staffattendances"
                      >Staff Attendance</router-link
                    >
                  </li> -->
                  <li>
                    <router-link to="staffleaves">Staff Leaves</router-link>
                  </li>
                </ul>
              </div>
              <div class="col-md-2">
                <h5 class="font-size-14 mt-0">
                  Human Resource
                </h5>
                <ul
                  class="list-unstyled megamenu-list"
                  v-if="userData.permissions['view_hr'] == 1"
                >
                  <li>
                    <router-link to="schooldepartments"
                      >Departments</router-link
                    >
                  </li>
                  <li>
                    <router-link to="positions">Positions</router-link>
                  </li>
                  <li>
                    <router-link to="staffmembers">Staff Members</router-link>
                  </li>
                  <li>
                    <router-link to="salarydetails">Salary Details</router-link>
                  </li>
                  <li>
                    <router-link to="allowances">Allowances</router-link>
                  </li>
                  <li>
                    <router-link to="staffadvances">Advances</router-link>
                  </li>
                  <li>
                    <router-link to="deductions">Deductions</router-link>
                  </li>
                </ul>
              </div>
              <div class="col-md-2">
                <h5 class="font-size-14 mt-0">
                  Other Features
                </h5>
                <ul
                  class="list-unstyled megamenu-list"
                  v-if="userData.permissions['others'] == 1"
                >
                  <li><router-link to="audits">Audit Trails</router-link></li>
                  <li>
                    <router-link to="chat">Inquiries & Complaints</router-link>
                  </li>
                  <li><router-link to="smscenter">SMS Center</router-link></li>
                  <li>
                    <router-link to="subscriptions">Subscriptions</router-link>
                  </li>
                  <li>
                    <router-link to="studymaterials"
                      >Study Materials</router-link
                    >
                  </li>
                  <li><router-link to="homework">Home Work</router-link></li>
                  <li><router-link to="events">School Events</router-link></li>
                </ul>
              </div>
            </div>
          </b-dropdown>
        </span>
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <b-button variant="primary" size="sm"
              ><i class="mdi mdi-google-translate me-1"></i> Translate
            </b-button>
          </template>
          <Translator
            :countries="arrayOfCountries"
            @on-country-click="customEvent"
          />
        </b-dropdown>

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <i class="mdi mdi-account-circle mdi-24px"></i>
            <span class="d-none d-xl-inline-block mt-n2 ms-1">
              {{ userData.username }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <a href="/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            Logout
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
